<template>
  <div style="minHeight:80vh">
    <p v-if="!dataavailable" style="font-size:1rem">选择多个数据库进行搜索</p>
    <el-input ref="generalsearch" clearable width="100%" placeholder="综合搜索Aggregation search" v-model="searchval"
      @keyup.enter.native="reload"></el-input>
    <aggtree></aggtree>
    <div v-if="load">
      <div v-for="x in collections" :key="x.label">
        <singleclct 
        @cilckfromsigleclct="cilckfromsigleclct" 
        @hasdata="dataavailable=true" 
        @headersetdone="headersetdone"
        :ifheaderoperate="true"
        :iffootermore="true"
        :thedata="datas[x.value]"
        :tabletitle="x.label" 
        :collection="x.value"
        :sortset="sortset"
        :matchrule="matchrule"
        :searchval="searchval"
        ></singleclct>
      </div>
    </div>
  </div>
</template>


<script>
import aggtree from "./aggtree";
import singleclct from "./singleclct";
export default {
  components: { singleclct, aggtree },
  mounted() {
    this.reload();
  },
  watch: {
    aggcollections(newval, oldval) {
      if (newval.length >= oldval.length) {
        this.reload();
      }
    }
  },
  data() {
    return {
      searchval:this.$store.state.targettxt,
      sortset:{},
      matchrule:{},
      dataavailable: false,
      load: false,
      datas: {},
    };
  },
  computed: {

    aggcollections() {
      return this.$store.state.aggcollections;
    },
    collections() {
      let objcollections = this.$store.state.collections.filter(obj => {
        return this.aggcollections.includes(obj.value);
      });
      return objcollections;
    },
    // targettxt: {
    //   get: function () {
    //     return this.$store.state.targettxt;
    //   },
    //   set: function (val) {
    //     this.$store.commit("settargettxt", val);
    //   }
    // }
  },

  methods: {
    headersetdone(obj){
      this.matchrule=Object.assign(this.matchrule,obj.matchrule) 
      // this.searchval=JSON.stringify(this.matchrule);
      
      this.sortset=Object.assign(this.sortset,obj.sortset)
      this.reload()
    },
    cilckfromsigleclct(singledata) {
      this.$emit("cilckfromsigleclct", singledata)
    },
    reload() {

      this.load = false;
      this.$axios
        .post(url + "aggregateclct", {
          collections: this.$store.state.aggcollections,
          value: this.searchval,//this.$store.state.targettxt
          matchrule:this.matchrule,
          sortset:this.sortset
        })
        .then(res => {
          this.datas = res.data;
          this.load = true;
          this.$emit("dataready", "dataready")
        });
    }


  }
};
</script>




// WEBPACK FOOTER //
// src/components/news/aggregate.vue